import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable()
export class CarouselQueryService {
    public GET_CAROUSELS: any;

    constructor(public apollo: Apollo) {
        this.GET_CAROUSELS =
            gql`
            query {                           
                allCarousels {
                  edges {
                    node {
                        content
                        author
                    }
                  }
                }
              }
        `
    }

    //get charge percentage
    GET_ALL_CAROUSELS() {

        return this.apollo
            .watchQuery({
                query: this.GET_CAROUSELS
                ,
                fetchPolicy: 'network-only'
            });

    }
}


// WEBPACK FOOTER //
// E:/NeoSME/1.Full Project Spekwo/pro/prodash/src/app/main/content/apps/gql-query-mutation/carousel.ts